import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MateriaService } from '../../../services/materia.service';
import { Location } from '@angular/common';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { Materia } from '../../../models/materia';
import { TemaService } from '../../../services/tema.service';
import { Tema } from '../../../models/tema';


@Component({
  selector: 'app-artigos',
  templateUrl: './artigos.component.html',
  styleUrls: ['./artigos.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ArtigosComponent implements OnInit, OnDestroy {
  materias: Materia[];
  temaNome: string;
  tema: Tema;

  @ViewChild('masonryGrid') masonryGridElem!: ElementRef<HTMLDivElement>;
  private msnry!: Masonry; // Store Masonry instance

  constructor(
    private route: ActivatedRoute,
    private materiaService: MateriaService,
    private temaService: TemaService,
    private _location: Location,
    private cdRef: ChangeDetectorRef // Inject ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const temaId = Number(params.get('id'));

      this.temaService.getById(temaId).subscribe((res) => {
        this.temaNome = res.nome;

        this.materiaService.getByTemaId(temaId).subscribe((mat) => {
          this.materias = mat;

          this.cdRef.detectChanges();
          this.initMasonry();
        });
      });
    });
  }

  initMasonry(): void {
    if (this.masonryGridElem && this.masonryGridElem.nativeElement && this.materias.length > 0) {
      // Ensure elements are in the DOM and there's data
      // Use imagesLoaded to wait for images before initializing or laying out
      imagesLoaded(this.masonryGridElem.nativeElement, () => {
        if (this.msnry) { // If Masonry instance already exists, just relayout
          this.msnry.reloadItems();
          this.msnry.layout();
        } else { // Otherwise, create a new instance
          this.msnry = new Masonry(this.masonryGridElem.nativeElement, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer', // Use .grid-sizer for column width
            percentPosition: true,
            gutter: 0, // Adjust this based on your .grid-item padding.
            // If .grid-item has padding: 8px, gutter: 0 works well.
            // Or, if .grid-item has no horizontal padding, gutter: 16 might be what you want.
            //initLayout: true, // Initialize layout immediately
          });
        }
      });
    }
  }

  onImageLoad(): void {
    if (this.msnry) {
      // Use a small timeout to ensure the image dimensions are fully updated in the DOM
      // before Masonry tries to re-layout. This can sometimes be necessary.
      setTimeout(() => {
        this.msnry.layout();
      }, 100);
    }
  }

  public handleMissingImage(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    // Option 1: Hide the image's parent card if an image is critical
    // imgElement.closest('.card')?.setAttribute('style', 'display:none !important');

    // Option 2: Just hide the image, card remains
    imgElement.style.display = 'none';

    // After hiding, relayout Masonry
    if (this.msnry) {
      setTimeout(() => this.msnry.layout(), 50); // Small delay
    }
  }

  backClicked() {
    this._location.back();
  }

  ngOnDestroy(): void {
    if (this.msnry) {
      this.msnry.destroy(); // Clean up Masonry instance
    }
  }

}
